// SEO Tab Component
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Button } from '../../../components/ui/button';
import { Plus, X, Globe, Newspaper } from 'lucide-react';

export const SeoTab = ({ 
  formData, 
  setFormData, 
  seoKeywordInput, 
  setSeoKeywordInput,
  addSeoKeyword,
  removeSeoKeyword
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Globe className="text-primary" size={20} />
        <div>
          <h3 className="font-medium">Parole Chiave Evento</h3>
          <p className="text-xs text-muted-foreground">
            Queste keywords si aggiungono a quelle generali del sito per questo evento specifico
          </p>
        </div>
      </div>
      
      <div className="flex gap-2 mb-3">
        <Input
          value={seoKeywordInput}
          onChange={(e) => setSeoKeywordInput(e.target.value)}
          placeholder="Aggiungi una keyword..."
          className="bg-white/5 border-white/10"
          onKeyPress={(e) => e.key === 'Enter' && (e.preventDefault(), addSeoKeyword())}
        />
        <Button type="button" variant="outline" onClick={addSeoKeyword}>
          <Plus size={14} />
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        {(formData.seo_keywords || []).map((keyword, index) => (
          <span key={`kw-${keyword}`} className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-400 text-sm flex items-center gap-2">
            {keyword}
            <button type="button" onClick={() => removeSeoKeyword(index)} className="hover:text-white">
              <X size={12} />
            </button>
          </span>
        ))}
      </div>

      {/* RSS Feed Section */}
      <div className="pt-4 border-t border-white/10 mt-6">
        <div className="flex items-center gap-2 mb-4">
          <Newspaper className="text-primary" size={20} />
          <div>
            <h3 className="font-medium">Feed RSS Notizie</h3>
            <p className="text-xs text-muted-foreground">
              Mostra articoli da un feed RSS nella pagina dell'evento
            </p>
          </div>
        </div>
        
        <div className="space-y-3">
          <div className="space-y-2">
            <Label>Titolo Sezione</Label>
            <Input
              value={formData.rss_feed_title || ''}
              onChange={(e) => setFormData({ ...formData, rss_feed_title: e.target.value })}
              placeholder="es. Ultime Notizie, News dal Blog..."
              className="bg-white/5 border-white/10"
            />
          </div>
          <div className="space-y-2">
            <Label>URL Feed RSS</Label>
            <Input
              value={formData.rss_feed_url || ''}
              onChange={(e) => setFormData({ ...formData, rss_feed_url: e.target.value })}
              placeholder="https://example.com/feed.xml"
              className="bg-white/5 border-white/10"
            />
            <p className="text-xs text-muted-foreground">
              Inserisci l'URL del feed RSS per mostrare gli ultimi articoli
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
